/* ============================================
   ECG Line Animation
   ============================================ */

(function () {
    'use strict';

    var ecgLines = document.querySelectorAll('.pg-ecg-line');
    if (!ecgLines.length) return;

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('animated');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.3
    });

    ecgLines.forEach(function (line) {
        observer.observe(line);
    });
})();
